import {useEffect, useState} from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {Stack} from "@mui/material";
import {useSnackbar} from "notistack";
import DeleteIcon from "@mui/icons-material/Delete";
import sendRequest from "../services/sendRequest";
import './YourStyles.css'; // Ensure to import the CSS file
import CircularProgress from "@mui/material/CircularProgress"; // Import Material-UI CircularProgress
import Backdrop from "@mui/material/Backdrop"; // Import Material-UI Backdrop
import Typography from "@mui/material/Typography"
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

const role=localStorage.getItem("role")

const AreYouSureDialog = ({open, confirm, cancel, message}) => (
  <Dialog open={open}>
    <DialogTitle>{message}</DialogTitle>
    <DialogContent
      sx={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Button onClick={cancel}>No</Button>
      <Button onClick={confirm}>Yes</Button>
    </DialogContent>
  </Dialog>
);

const EditDataChannel = ({
  open,
  openEditDialogue,
  options,
  order,
  rowToEdit,
  page,
  setRefresh,
  isAdd,
}) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const [data, setData] = useState({});
  const [cms, setCms] = useState(""); // Initialize with an empty string
  const [channelName, setChannelName] = useState(""); // Initialize with 
  const [areYouSureOpen, setAreYouSureOpen] = useState(false);
  const [timer, setTimer] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // State to track 
  
  useEffect(() => {
    if (rowToEdit && rowToEdit !== "add" && Object.keys(rowToEdit).length > 0) {
      setCms(rowToEdit.cms); // Set default value to avoid undefined
      setChannelName(rowToEdit.channel_name); // Set default value to avoid undefined
    }
    if(rowToEdit && rowToEdit == "add") {
      setCms(""); // Set default value to avoid undefined
      setChannelName(""); // Set default value to avoid undefined
    }
  }, [rowToEdit]);

  const validateCustomeId = async (value) => {
    if (value !== "") {
      try {
        setIsLoading(true); // Start loading
        const response = await sendRequest({
          requestType: "get",
          endpoint: `${page}/validateCustomId?customId=${value}`,
        });
        console.log(response);

        // Check if response contains the required data
        if (response && response.data && response.data.state) {
          return response.data.state; // Return true if state is valid
        }
        return false; // Return false if state is not valid
      } catch (error) {
        // Handle API call errors
        handleAllTypesOfMessages(`An error occurred while fetching data for Channel ID ${value} Please try again later.`, 'error');
        console.error("Error during API call:", error);
        return false; // Return false in case of an error
      } finally {
        setIsLoading(false); // End loading
      }
    }
    return false; // Return false if value is empty
  };

  const submitEdit = async () => {
    // check if any changes have actually been made
    if (Object.keys(data).length === 0) {
      handleAllTypesOfMessages("No changes to update", "info");
      return;
    }
    if(data != null && page === "customIdsPerChannel" ){ 
      if(cms && cms !="") {
        data.cms = cms;
      }
      if(channelName && channelName !="") {
        data.channel_name = channelName;
      }
      if(rowToEdit === "add") {
        if (data && (!data.hasOwnProperty('custom_id') || data.custom_id === "")) {
          handleAllTypesOfMessages('Please enter the custom_id before proceeding.', 'warning')
          return;
        } else {
          if(data.custom_id.length >= 7){
            const firstSevenCharacters = data.custom_id.substring(0, 7);
            const customIdPattern = /^[A-Z0-9]{3}-[A-Z0-9]{3}$/; // Regex for AAA-HHH format
            if (!customIdPattern.test(firstSevenCharacters)) {
              handleAllTypesOfMessages("The custom_id should be in the format 'AAA-BBB' (3 characters, a dash, then 3 characters), where each character can be an uppercase letter (A-Z) or a number (0-9)", 'warning')
              return;
            } else {
              if (!(await validateCustomeId(firstSevenCharacters))) {
                handleAllTypesOfMessages(`The entered custom_id "${firstSevenCharacters}" does not match any associated program. Please enter a valid custom_id that corresponds to a program.` , 'warning')
                return;
              } else {
                data.custom_id = firstSevenCharacters+"-"+"S000-EP000";
              }
            }
          } else {
            handleAllTypesOfMessages("The custom_id should be in the format 'AAA-BBB' (3 characters, a dash, then 3 characters), where each character can be an uppercase letter (A-Z) or a number (0-9)", 'warning')
            return;
          }
        }
        if (data && (!data.hasOwnProperty('cms') || data.cms === "" || !data.hasOwnProperty('cms') || data.cms === "")) {
          handleAllTypesOfMessages("Please load the Channel Name and CMS by entering the correct Channel ID before proceeding.", 'warning')
          return;
        }
      } else {
         if (data && data.custom_id === "") {
          handleAllTypesOfMessages("Please enter the custom_id before proceeding.", 'warning')
          return;
        } else {
          if(data.custom_id.length >= 7){
            const firstSevenCharacters = data.custom_id.substring(0, 7);
            const customIdPattern = /^[A-Z0-9]{3}-[A-Z0-9]{3}$/; // Regex for AAA-HHH format
            if (!customIdPattern.test(firstSevenCharacters)) {
              handleAllTypesOfMessages("The custom_id should be in the format 'AAA-BBB' (3 characters, a dash, then 3 characters), where each character can be an uppercase letter (A-Z) or a number (0-9)", 'warning')
              return;
            } else {
              if (!(await validateCustomeId(firstSevenCharacters))) {
                handleAllTypesOfMessages(`The entered custom_id "${firstSevenCharacters}" does not match any associated programme. Please enter a valid custom_id that corresponds to a programme.`, 'warning')
                return;
              } else {
                data.custom_id = firstSevenCharacters+"-"+"S000-EP000";
              }
            }
          } else {
            handleAllTypesOfMessages("The custom_id should be in the format 'AAA-BBB' (3 characters, a dash, then 3 characters), where each character can be an uppercase letter (A-Z) or a number (0-9)", 'warning')
            return;
          }
        }
        if (data && data.cms === "" || data.cms === "") {
          handleAllTypesOfMessages("Please load the Channel Name and CMS by entering the correct Channel ID before proceeding.", 'warning')
          return;
        }
      }
    }

    if (isAdd) {
      const response = await sendRequest({
        requestType: "post",
        endpoint: `${page}/`,
        requestData: data,
      });
      if (response?.status === 201) {
        handleAllTypesOfMessages("Data successfully added!", "success");
        openEditDialogue(false);
        setRefresh((oldState) => !oldState);
      } else if (response?.response?.request?.responseText) {
        // iterate over error messages and snack each error.
        const responseErrors = JSON.parse(
          response?.response?.request?.responseText
        );
        Object.keys(responseErrors).forEach((fieldName) =>
          responseErrors[fieldName].forEach((errorMessage) => {
            if (typeof errorMessage == "object") {
              console.log(errorMessage);
              Object.keys(errorMessage).forEach((key) => {
                handleAllTypesOfMessages(
                  `${fieldName} - ${key} - ${errorMessage[key][0]}`,
                  "warning"
                );
              });
            } else {
              handleAllTypesOfMessages(`${fieldName} - ${errorMessage}`, "warning");
            }
          })
        );
      } else {
        handleAllTypesOfMessages("There was an error adding the data.", "warning");
      }
      // for editing an existing row
    } else {
      let patchId;
      if (!rowToEdit?.id) {
        if (!rowToEdit?.custom_id) {
          patchId = rowToEdit.custom_id_stem;
        } else {
          patchId = rowToEdit.custom_id;
        }
      } else {
        patchId = rowToEdit.id;
      }
      
      const response = await sendRequest({
        requestType: "patch",
        endpoint: page === "reports" ? `${page}/` : `${page}/${patchId}/`,
        requestData: page === "reports" ? "reportShareData" : data,
      });
      console.log(response);
      if (response?.status === 200) {
          handleAllTypesOfMessages("Data successfully updated!", "success");
          setRefresh((oldState) => !oldState);
          openEditDialogue(false);
          setData({});
        return;
      }   
      if (response.response.status === 400) {
        handleAllTypesOfMessages(response.response.data[0], "warning");
        localStorage.setItem("rulesForCompare", JSON.stringify([]));
        return;
      }

      if (response?.response?.status >= 500) {
        localStorage.setItem("rulesForCompare", JSON.stringify([]));
        handleAllTypesOfMessages(
          "There was an internal server error, data not updated",
          "warning"
        );
        return;
      }

      if (response?.response?.request?.responseText) {
        // iterate over error messages and snack each error.
        const responseErrors = JSON.parse(
          response?.response?.request?.responseText
        );
        Object.keys(responseErrors).forEach((fieldName) =>
          responseErrors[fieldName].forEach((errorMessage) =>
            handleAllTypesOfMessages(`${fieldName} - ${errorMessage}`, 
              "warning")
          )
        );
        return;
      }

      handleAllTypesOfMessages("There was an error updating the data.", "warning");
    }
    localStorage.setItem("rulesForCompare", JSON.stringify([]));
  };

  const handleDelete = async ({confirmed}) => {
    if (!confirmed) setAreYouSureOpen(true);
    else {
      let deleteId;
      if (!rowToEdit?.id) {
        if (!rowToEdit?.custom_id) {
          deleteId = rowToEdit.custom_id_stem;
        } else {
          deleteId = rowToEdit.custom_id;
        }
      } else {
        deleteId = rowToEdit.id;
      }
      const response = await sendRequest({
        requestType: "delete",
        endpoint: `${page}/${deleteId}/`,
      });
      if (
        response?.status === 202 ||
        response?.status === 200 ||
        response?.status === 204
      ) {
        handleAllTypesOfMessages("Data successfully deleted!", "success");
        openEditDialogue(false);      
        setRefresh((oldState) => !oldState);
      } else {
        handleAllTypesOfMessages("There was an error deleting the data.", "warning");
      }
    }
  };

  useEffect(() => {
    console.log("Updated cms:", cms);
  }, [cms]);

  useEffect(() => {
    console.log("Updated channelName:", channelName);
  }, [channelName]);

  const collectData = (value) => {
    console.log(`Data collected: ${value}`);
    // Add your logic to handle the collected data here
    if(data != null && page === "customIdsPerChannel" ) { 
      // Clear the previous timer
      if (timer) {
        clearTimeout(timer);
      }  
      // Set a new timer
      const newTimer = setTimeout(() => {
        loadChanelNameAndCmsByChannelId(value);
      }, 5000); // 1 minute delay  
      setTimer(newTimer);
    }
  };

  // Function to handle the API call
  const loadChanelNameAndCmsByChannelId = async (value) => {
    if (value !== "") {
      try {
        setIsLoading(true); // Start loading
        const response = await sendRequest({
          requestType: "get",
          endpoint: `${page}/search?searchString=${value}`,
        });

        // Validate the response structure
        if (
          response &&
          response.data &&
          Array.isArray(response.data.data) &&
          response.data.data.length > 0
        ) {
          const firstRecord = response.data.data[0];
          const channelTitle = firstRecord.channel_title; // Fallback to an empty string
          const tableSuffix = firstRecord.table_suffix; // Fallback to an empty string

          if (channelTitle !== "" && tableSuffix !== "") {
            // Both values are non-empty
            setChannelName(channelTitle);
            setCms(tableSuffix);
            handleAllTypesOfMessages(`Based on the entered Channel ID '${value}', we have fetched the Channel Name and CMS. Please validate the information once before submitting.`, 'success')
          } else {
            // Either channelTitle or tableSuffix is empty
            setChannelName("");
            setCms("");
            setData((prevData) => ({
              ...prevData,
              cms: "",
              channel_name: "",
            }));
            handleAllTypesOfMessages(`For the Channel ID "${value}", we don't have any associated Channel Name and CMS. Please try to enter a valid Channel ID to get Channel Name and CMS information.`, 'warning')
          }
        } else {
          // Invalid or empty response structure
          setChannelName("");
          setCms("");
          setData((prevData) => ({
            ...prevData,
            cms: "",
            channel_name: "",
          }));
          handleAllTypesOfMessages(`No data found for the entered Channel ID "${value}". Please try again with a valid Channel ID.`, 'warning')
          console.error("Invalid response structure or empty data array.");
        }
      } catch (error) {
        // Handle API call errors
        handleAllTypesOfMessages(
          `An error occurred while fetching data for Channel ID "${value}". Please try again later.`,
          "error"
        );
        console.error("Error during API call:", error);
      } finally {
        setIsLoading(false); // End loading
      }
    }
  };

  //handleAllTypesOfMessages
  // const handleAllTypesOfMessages = (message, type) => {
  //   enqueueSnackbar(message, {
  //     variant: type,
  //   });
  // };

  //handleAllTypesOfMessages
  const handleAllTypesOfMessages = (message, type) => {
    const action = (key) => (
      <IconButton
        aria-label="close"
        color="inherit"
        onClick={() => closeSnackbar(key)}
      >
        <CloseIcon />
      </IconButton>
    );

    enqueueSnackbar(message, {
      variant: type,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      persist: true, // <- keeps the snackbar visible until manually closed
      // autoHideDuration: 20000,
      action
    });
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          setData({});
          openEditDialogue(false);
        }}
        fullWidth={true}
        sx={{
          '& .MuiDialog-paper': {
            width: '80%', // Adjust the width as needed
            height: '80%', // Adjust the height as needed
            maxWidth: 'none', // Override the default maxWidth
            maxHeight: 'none', // Override the default maxHeight
          },
        }}
      >
        <Backdrop
          open={isLoading} // Show the backdrop when loading
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            display: "flex",
            flexDirection: "column", // Stack spinner and message vertically
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="inherit" /> {/* Spinner */}
          <Typography
            variant="h6"
            sx={{
              marginTop: 2, // Add spacing between spinner and message
              color: "#fff",
            }}
          >
            Data is being loaded, please wait...
          </Typography>
        </Backdrop>

        <Stack
          m={1}
          mb={-2}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <DialogTitle>{`${isAdd ? "Add" : "Edit"} Data`}</DialogTitle>
          {!isAdd && role=== 'full access' && (
            <Button
              onClick={handleDelete}
              startIcon={<DeleteIcon />}
              color="error"
              sx={{height: 40}}
            >
              Delete
            </Button>
          )}
        </Stack>
        <DialogContent>
          {options &&
            order.map((header, index) => {
                // Skip rendering TextField if the label is "id"
                if (options[header].label === "Id") {
                  return null;
                }
                return (
                  <TextField
                    key={header}
                    margin="normal"
                    disabled={
                      (options[header].label === "Channel name" && page === "customIdsPerChannel") ||
                      (options[header].label === "Cms" && page === "customIdsPerChannel")
                        ? true
                        : options[header].read_only
                    }
                    label={options[header]?.label || header}
                    value={
                      header === "cms"
                        ? cms
                        : header === "channel_id"
                        ? data[header] ?? rowToEdit[header] ?? ""
                        : header === "channel_name"
                        ? channelName
                        : header === "custom_id"
                        ? data[header] ?? rowToEdit[header] ?? ""
                        : data[header] ?? rowToEdit[header] ?? ""
                    }
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setData((oldState) => {
                        return { ...oldState, [header]: newValue };
                      });

                      if (page === "customIdsPerChannel" && options[header].label === "Channel id") {
                        collectData(newValue); // Call your method to collect data
                      }

                      if (header === "cms") {
                        setCms(newValue);
                      } else if (header === "channel_name") {
                        setChannelName(newValue);
                      }
                    }}
                    fullWidth
                  />
                );
            })}
            <DialogActions>
              <Button
                onClick={() => {
                  openEditDialogue(false);
                  setData({});
                }}
              >
                Cancel
              </Button>
              <Button onClick={() => submitEdit(data)}>Submit</Button>
            </DialogActions>          
        </DialogContent>
      </Dialog>
      <AreYouSureDialog
        open={areYouSureOpen}
        page={page}
        message={`Are you sure you want to delete this ${
          page.charAt(page.length - 1) === "s"
            ? page.substring(0, page.length - 1)
            : page
        }?`}
        confirm={() => {
          handleDelete({confirmed: true});
          setAreYouSureOpen(false);
        }}
        cancel={() => setAreYouSureOpen(false)}
      />
    </>
  );
};

export default EditDataChannel;
